import React from 'react'
import PropTypes from 'prop-types'
import { intlFormat } from '@/modern/utils/transformString'
import * as S from './style'

const Price = ({ value, isHorizontal }) => {
  const valueIsNumber = typeof value === 'number'
  const formattedValue = valueIsNumber
    ? intlFormat(value)
    : intlFormat(value.split(' ')[1])

  return <S.Price isHorizontal={isHorizontal}>{formattedValue}</S.Price>
}

Price.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isHorizontal: PropTypes.bool,
}

Price.defaultProps = {
  isHorizontal: false,
}

export default Price
